import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "absolute top-0 left-0 w-full h-full bg-white dark:bg-gray-850 rounded-lg z-10 text-center" }
const _hoisted_2 = { class: "flex flex-col justify-between items-center h-full p-4" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h3", null, "Your investment pool has been created", -1)
const _hoisted_4 = { class: "flex flex-col items-center" }
const _hoisted_5 = { class: "w-20 h-20 rounded-full flex items-center justify-center bg-green-100 dark:bg-green-500 text-green-500 dark:text-gray-850 mb-8" }
const _hoisted_6 = /*#__PURE__*/_createVNode("p", { class: "text-gray-300" }, " Your investment pool has been successfully created and joined. You're good to go! ", -1)
const _hoisted_7 = { class: "grid grid-cols-1 gap-4 mt-4 w-full" }
const _hoisted_8 = /*#__PURE__*/_createVNode("span", null, "Take me to my pool", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BalIcon = _resolveComponent("BalIcon")
  const _component_BalBtn = _resolveComponent("BalBtn")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode(_component_BalIcon, {
            name: "check-circle",
            size: "xl"
          })
        ]),
        _hoisted_6
      ]),
      _createVNode("div", _hoisted_7, [
        _createVNode(_component_BalBtn, { onClick: _ctx.navigateToPool }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ])
  ]))
}